(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  const wishlistHeader = document.querySelector('.header__icon--wishlist');
  if (wishlistHeader) {
    const normalizeWishlistCount = () => {
      const badge = wishlistHeader.querySelector('.wishlist-hero-items-count');
      if (!badge) return;
      const count = badge.textContent.replace(/[()\s]/g, '');
      if (badge.textContent !== count) badge.textContent = count;
    };
    new MutationObserver(normalizeWishlistCount).observe(wishlistHeader, {subtree: true, childList: true, characterData: true});
    normalizeWishlistCount();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
function setupSkrBlog(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const heading = root.querySelector('.skr-blog__section-heading h2');
  const originalHeading = heading.textContent;
  const empty = root.querySelector('[data-skr-empty]');
  const cards = root.querySelectorAll('.skr-blog__card');
  const links = root.querySelectorAll('.skr-blog__filters a');
  const originalActive = root.querySelector('.skr-blog__filters [aria-current="page"]');
  function update() {
    const match = Array.from(links).find(link => link.hash.startsWith('#onderwerp-') && link.hash === window.location.hash);
    cards.forEach(card => { card.hidden = Boolean(match); });
    if (empty) empty.hidden = !match;
    heading.textContent = match ? match.textContent.trim() : originalHeading;
    links.forEach(link => {
      const active = match ? link === match : link === originalActive;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  update();
  window.addEventListener('hashchange', update);
}
document.querySelectorAll('.skr-blog').forEach(setupSkrBlog);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.skr-blog').forEach(setupSkrBlog);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samenkr-amazon-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.skr-product').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const mainImage = root.querySelector('.skr-product__main-image');
      const imageDialog = root.querySelector('[data-image-dialog]');
      root.querySelector('[data-zoom]')?.addEventListener('click', () => {
        if (!imageDialog || !mainImage) return;
        const zoomImage = imageDialog.querySelector('img');
        const activeThumb = root.querySelector('.skr-product__thumb.is-active');
        zoomImage.src = activeThumb?.dataset.image || mainImage.currentSrc || mainImage.src;
        zoomImage.alt = mainImage.alt;
        imageDialog.showModal();
      });
      root.querySelector('[data-close-zoom]')?.addEventListener('click', () => imageDialog.close());
      imageDialog?.addEventListener('click', (event) => {
        if (event.target === imageDialog) imageDialog.close();
      });
      const wishlistSlot = root.querySelector('[data-wishlist-slot]');
      const panel = root.querySelector('.skr-product__panel');
      if (wishlistSlot && panel) {
        const placeWishlist = () => {
          const wishlistButton = panel.querySelector('button.product__form--add-to-cart');
          if (wishlistButton && wishlistButton.parentElement !== wishlistSlot) {
            wishlistButton.type = 'button';
            wishlistSlot.append(wishlistButton);
          }
        };
        const wishlistObserver = new MutationObserver(placeWishlist);
        wishlistObserver.observe(panel, { childList: true, subtree: true });
        placeWishlist();
      }
      root.querySelectorAll('.skr-product__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = thumb.dataset.image;
            mainImage.alt = thumb.dataset.alt || '';
          }
          root.querySelectorAll('.skr-product__thumb').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const sticky = root.querySelector('[data-sticky-buy]');
      const mainAdd = root.querySelector('[data-add]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      if (sticky && mainAdd && stickyAdd) {
        const syncSticky = () => {
          const buttonBounds = mainAdd.getBoundingClientRect();
          const buttonVisible = buttonBounds.top < window.innerHeight && buttonBounds.bottom > 0;
          sticky.hidden = !window.matchMedia('(max-width: 749px)').matches || buttonVisible || root.getBoundingClientRect().bottom < 100;
          stickyAdd.disabled = mainAdd.disabled;
          sticky.querySelector('[data-sticky-price]').textContent = root.querySelector('[data-price]').textContent;
        };
        stickyAdd.addEventListener('click', () => {
          if (!mainAdd.disabled) mainAdd.closest('form').requestSubmit(mainAdd);
        });
        window.addEventListener('scroll', syncSticky, { passive: true });
        window.addEventListener('resize', syncSticky);
        root.querySelector('[data-variant]')?.addEventListener('change', () => requestAnimationFrame(syncSticky));
        syncSticky();
      }

      const variant = root.querySelector('[data-variant]');
      if (!variant) return;
      variant.addEventListener('change', () => {
        const option = variant.options[variant.selectedIndex];
        const available = option.dataset.available === 'true';
        root.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-compare-price]');
        if (compare) compare.textContent = option.dataset.comparePrice || '';
        const stock = root.querySelector('[data-stock]');
        stock.textContent = available ? stock.dataset.inStock : stock.dataset.outOfStock;
        stock.classList.toggle('is-out', !available);
        const button = root.querySelector('[data-add]');
        button.disabled = !available;
        button.textContent = available ? button.dataset.addText : button.dataset.soldText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samenkr-club-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.skr-product').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const mainImage = root.querySelector('.skr-product__main-image');
      root.querySelectorAll('.skr-product__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = thumb.dataset.image;
            mainImage.alt = thumb.dataset.alt || '';
          }
          root.querySelectorAll('.skr-product__thumb').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const sticky = root.querySelector('[data-sticky-buy]');
      const mainAdd = root.querySelector('[data-add]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      if (sticky && mainAdd && stickyAdd) {
        const syncSticky = () => {
          const buttonBounds = mainAdd.getBoundingClientRect();
          const buttonVisible = buttonBounds.top < window.innerHeight && buttonBounds.bottom > 0;
          sticky.hidden = !window.matchMedia('(max-width: 749px)').matches || window.scrollY < 280 || buttonVisible || root.getBoundingClientRect().bottom < 100;
          stickyAdd.disabled = mainAdd.disabled;
          sticky.querySelector('[data-sticky-price]').textContent = root.querySelector('[data-price]').textContent;
        };
        stickyAdd.addEventListener('click', () => {
          if (!mainAdd.disabled) mainAdd.closest('form').requestSubmit(mainAdd);
        });
        window.addEventListener('scroll', syncSticky, { passive: true });
        window.addEventListener('resize', syncSticky);
        root.querySelector('[data-variant]')?.addEventListener('change', () => requestAnimationFrame(syncSticky));
        syncSticky();
      }

      const variant = root.querySelector('[data-variant]');
      if (!variant) return;
      variant.addEventListener('change', () => {
        const option = variant.options[variant.selectedIndex];
        const available = option.dataset.available === 'true';
        root.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-compare-price]');
        if (compare) compare.textContent = option.dataset.comparePrice || '';
        const stock = root.querySelector('[data-stock]');
        stock.textContent = available ? stock.dataset.inStock : stock.dataset.outOfStock;
        stock.classList.toggle('is-out', !available);
        const button = root.querySelector('[data-add]');
        button.disabled = !available;
        button.textContent = available ? button.dataset.addText : button.dataset.soldText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samenkr-home-sales"] && !Shopify.designMode) return;
  try {
    
function skrSetupTabs(root){root.querySelectorAll('.skr-new').forEach(section=>{if(section.dataset.tabsReady)return;section.dataset.tabsReady='true';const tabs=[...section.querySelectorAll('[data-skr-tab]')];function activate(tab){tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});section.querySelectorAll('[data-skr-panel]').forEach(panel=>panel.hidden=panel.dataset.skrPanel!==tab.dataset.skrTab);}tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next]);tabs[next].focus();}});});});}skrSetupTabs(document);document.addEventListener('shopify:section:load',()=>skrSetupTabs(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skr-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'skr_recent_products_v1';
    const initialize = (scope) => {
      scope.querySelectorAll('[data-skr-recent]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const imageUrl = (value) => {
          try {
            if (!value) return null;
            const url = new URL(value, window.location.origin);
            const storefrontHosts = [window.location.hostname, root.dataset.storeHost, root.dataset.permanentHost];
            const isStoreImage = storefrontHosts.includes(url.hostname) && url.pathname.startsWith('/cdn/shop/');
            if (url.protocol === 'https:' && !url.username && !url.password && (isStoreImage || url.hostname === 'cdn.shopify.com')) return url.href;
          } catch (error) {}
          return null;
        };
        const productUrl = (value) => {
          try {
            const url = new URL(value, window.location.origin);
            if (url.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return url.pathname + url.search;
          } catch (error) {}
          return null;
        };
        let saved = [];
        try { saved = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (error) {}
        const items = Array.isArray(saved) ? saved.filter((entry) => entry && typeof entry === 'object' && Date.now() - Number(entry.at) < 2592000000 && productUrl(entry.url)) : [];
        const currentId = root.dataset.currentId;
        const grid = root.querySelector('[data-recent-grid]');
        items.filter((entry) => String(entry.id) !== currentId).slice(0, 4).forEach((entry) => {
          const item = document.createElement('li');
          item.className = 'skr-recently-viewed__item';
          const link = document.createElement('a');
          link.className = 'skr-recently-viewed__card';
          link.href = productUrl(entry.url);
          const media = document.createElement('span');
          media.className = 'skr-recently-viewed__media';
          media.setAttribute('aria-hidden', 'true');
          const fallback = () => media.replaceChildren(root.querySelector('[data-recent-placeholder]').content.cloneNode(true));
          const source = imageUrl(entry.image);
          if (source) {
            const image = document.createElement('img');
            image.alt = '';
            image.width = 80;
            image.height = 80;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.addEventListener('error', fallback, { once: true });
            image.src = source;
            media.appendChild(image);
          } else {
            fallback();
          }
          const details = document.createElement('span');
          details.className = 'skr-recently-viewed__details';
          const title = document.createElement('span');
          title.className = 'skr-recently-viewed__title';
          title.textContent = entry.title || '';
          const price = document.createElement('strong');
          price.className = 'skr-recently-viewed__price';
          price.textContent = entry.price || '';
          details.append(title, price);
          link.append(media, details);
          item.appendChild(link);
          grid.appendChild(item);
        });
        root.hidden = !grid.children.length;
        if (currentId) {
          items.unshift({ id: currentId, title: root.dataset.currentTitle, url: root.dataset.currentUrl, image: imageUrl(root.dataset.currentImage), price: root.dataset.currentPrice, at: Date.now() });
          const unique = items.filter((entry, index, list) => list.findIndex((other) => String(other.id) === String(entry.id)) === index).slice(0, 10);
          try { localStorage.setItem(storageKey, JSON.stringify(unique)); } catch (error) {}
        }
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
